import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { AnimatePresence, motion } from 'framer-motion';

import ClosingConfirmModal from './components/ClosingConfirmModal';
import Introduction from './steps/Introduction';
import Diagnostics from './steps/Diagnostics';
import DiagsUploader from './steps/DiagsUploader';
import PackMax from './steps/PackMax';
import PhotoMeeting from './steps/PhotoMeeting';
import Paiement from './steps/Paiement';
import SuccessAnimation from './steps/SuccessAnimation';

import { Modal, LoadingCircle } from 'hosman-material';

import { getPhotoPacks, updateStep } from '../../../../../../../reducers/SellerApp/photoMeetingsSlice';

const NewPhotoMeetingModal = () => {
  const { sale } = useSelector((state) => state.sellerSales);
  const { newPhotoMeetingParams: { step }, newPhotoMeetingParams: { isSubmitting } } = useSelector((state) => state.sellerPhotoMeetings);
  const [isClosing, setIsClosing] = useState(false)
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getPhotoPacks(sale.id));
  }, []);

  useEffect(() => {
    dispatch(updateStep('Introduction'))

    return () => dispatch(updateStep(null))
  }, []);

  const handleClosing = () => {
    if (isSubmitting) return;

    setIsClosing(true);
  }

  const motionContainer = (Component) => {
    return (
      <motion.div
        key={Component.name}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.3 }}
      >
        <Component />
      </motion.div>)
    }

  const renderContent = () => {
    switch (step) {
      case 'Introduction':
        return motionContainer(Introduction);
      case 'Diagnostics':
        return motionContainer(Diagnostics);
      case 'DiagsUploader':
        return motionContainer(DiagsUploader);
      case 'PackMax':
        return motionContainer(PackMax);
      case 'PhotoMeeting':
        return motionContainer(PhotoMeeting);
      case 'Paiement':
        return motionContainer(Paiement);
      case 'SuccessAnimation':
        return motionContainer(SuccessAnimation);
      default:
        return <LoadingCircle />;
    }
  };

  return (
    <>
      {isClosing && <ClosingConfirmModal setIsClosing={setIsClosing} />}

      <Modal isOpen closeModal={() => handleClosing()}>
        <div className='p-8 text-ih-indigo bg-ih-purple-5 md:max-w-2xl' id='ModalContent' data-testid='NewPhotoMeetingModal'>
          <AnimatePresence mode='wait'>
            {renderContent()}
          </AnimatePresence>
        </div>
      </Modal>
    </>
  )
}

export default NewPhotoMeetingModal;
